import React from 'react'
import { useRouter } from 'next/router'

import styled from '@emotion/styled'

import { FullWidthButton } from 'components/common/FullWidthButton'

const RWGFooter = ({ store_id }) => {
  const router = useRouter()

  return (
    <Container>
      <Button
        onClick={() =>
          router.push(`/rwg/${store_id}`, `/rwg/${store_id}`, { locale: false })
        }
      >
        Reservation
      </Button>
    </Container>
  )
}

export default RWGFooter

const Container = styled.footer`
  max-width: 480px;
  width: 100%;
  background-color: white;

  position: fixed;
  bottom: 0;
  z-index: 1;
  padding: 16px 0;
  border-top: 1px solid #eee;

  display: flex;
  justify-content: center;
  align-items: center;

  .interested {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
  }
`

const Button = styled(FullWidthButton)`
  width: 260px;
  height: 50px;
  margin: 0;
  background-color: #393939;
`
